import { Injectable } from '@angular/core';
import { TaskInput } from '../../entities/taskInput/taskInput';
import { TaskLinkInput } from '../../entities/taskLinkInput/taskLinkInput';
import { TaskLinkCandidate } from '../../interfaces/taskLinkCandidate';
import { Task } from 'src/app/rent-module/shared/entities/task/task';
interface EntityLinkInput {
    id?: string;
    outwardEntityId: string;
    outwardEntityType: string;
    inwardEntityId: string;
    inwardEntityType: string;
    linkType: string;
    role?: string;
}

interface ID {
  id: string;
}

interface LinkedEntityConnection {
  linkId: string;
  linkType: string;
  linkedEntity: ID;
}

/**
 * Tasks service.
 */
@Injectable()
export class TaskLinkService {
  constructor() {}

  buildEntityLinksFromTaskLinkCandidates(taskInput: TaskInput, taskLinkCandidates: TaskLinkCandidate[], linkedEntities: LinkedEntityConnection[]){
    if(!taskInput || !taskLinkCandidates || taskLinkCandidates.length === 0){
      return;
    }
    if(!taskInput.entityLinks) {
      taskInput.entityLinks = [];
    }
    taskLinkCandidates.forEach(taskLinkCandidate => {
      taskInput.entityLinks.push(this.buildEntityLinkInput(taskInput.id, taskLinkCandidate, linkedEntities));
    });
  }

  buildEntityLinksFromTaskLinkCandidate(taskInput: TaskInput, taskLinkCandidate: TaskLinkCandidate, linkedEntities: LinkedEntityConnection[]){
    if(!taskInput || !taskLinkCandidate ){
      return;
    }
    if(!taskInput.entityLinks) {
      taskInput.entityLinks = [];
    }
    taskInput.entityLinks.push(this.buildEntityLinkInput(taskInput.id, taskLinkCandidate, linkedEntities));
  }

  buildEntityLinkInput(taskId: string, taskLinkCandidate: TaskLinkCandidate, linkedEntities: LinkedEntityConnection[]): EntityLinkInput {
    let entityLinkInput: EntityLinkInput = {
      id: linkedEntities.find(linkedEntity => linkedEntity.linkedEntity.id === taskLinkCandidate.getId())?.linkId,
      inwardEntityId: taskLinkCandidate.getId(),
      inwardEntityType: taskLinkCandidate.getLinkedEntityType(),
      outwardEntityId: taskId,
      outwardEntityType: "Task",
      linkType: "RELATED_TO",
    };
    console.log("buildEntityLinkInput", entityLinkInput);
    return entityLinkInput;
  }

}
